"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DojoGaugeTotal = void 0;
/**
 * Wrapper class around JavaScript's Number. Percentage multiplier for amount of
 * notes in the song notation that is applied to gauge calculation.
 */
class DojoGaugeTotal extends Number {
    /**
     * If this is true, it is impossible to get a full gauge.
     */
    get isImpossible() {
        return this < 100;
    }
    /**
     * If this is true, all notes are required to be hit perfectly.
     */
    get areAllNotesRequired() {
        return this === 100;
    }
    /**
     * If this is true, it is easier to fill the gauge.
     */
    get isEasier() {
        return this > 100;
    }
}
exports.DojoGaugeTotal = DojoGaugeTotal;
